import { useEffect } from 'react';
import { isServer } from '@doda/common/src/utils/isServer';
import {
  LocalStorageUtil,
  ViewCount,
} from '@doda/common/src/utils/localStorageUtil';

/**
 * localStorageからviewCountを取得する
 */
export const getViewCount = () => {
  if (!isServer) {
    return (LocalStorageUtil.getItem('viewCount') as Array<ViewCount>) ?? [];
  }
  return [];
};

/**
 * 閲覧回数hooks
 */
export const useViewCount = () => {
  useEffect(() => {
    const viewCountList = getViewCount();
    LocalStorageUtil.setItem(
      'viewCount',
      viewCountList.filter(
        (count) => count.date >= new Date().getTime() - 30 * 24 * 60 * 60 * 1000
      )
    );
  }, []);

  const getCount = (id: string) => {
    const viewCountList = getViewCount();

    const viewCount = viewCountList.find((i) => i.wjoid === id);
    return viewCount;
  };

  const addCount = (id: string) => {
    const viewCountList = getViewCount();
    if (viewCountList.some((i) => i.wjoid === id)) {
      LocalStorageUtil.setItem(
        'viewCount',
        viewCountList.map((i) => {
          if (i.wjoid === id) {
            i.count += 1;
            i.date = new Date().getTime();
          }
          return i;
        })
      );
    } else {
      const newList = viewCountList;
      newList.push({
        wjoid: id,
        count: 1,
        date: new Date().getTime(),
      });
      LocalStorageUtil.setItem('viewCount', newList);
    }
  };

  const resetCount = (id: string) => {
    const viewCountList = getViewCount();
    LocalStorageUtil.setItem(
      'viewCount',
      viewCountList.splice(viewCountList.findIndex((i) => i.wjoid === id))
    );
  };

  return { addCount, resetCount, getCount };
};
